import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex max-h-96 min-h-0 flex-1 flex-col gap-2 overflow-hidden px-2 pb-2" }

import {
        Collapsible,
        CollapsibleTrigger,
        CollapsibleContent,
    } from '@/components/ui/collapsible';
    import { createLogFilterColumns } from '@/tables/columns/log-filters';
    import LogFilterTable from '@/components/log/LogFilterTable.vue';
    import { useLogStore } from '@/stores/log';
    import { useQueryClient } from '@tanstack/vue-query';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LogFilter',
  props: {
    name: {},
    label: {},
    loading: { type: Boolean },
    data: {}
  },
  setup(__props: any) {

    const logStore = useLogStore();
    const queryClient = useQueryClient();

    const props = __props;

    const columns = createLogFilterColumns(props.label);

    const handleFilterSelection = (rowSelection: string[]) => {
        logStore.updateRowSelection(rowSelection, props.name);
        queryClient.invalidateQueries({ queryKey: [QueryKey.LOGS] });
        queryClient.invalidateQueries({ queryKey: [QueryKey.ACTIVITIES] });
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Collapsible), {
    open: _unref(logStore).openFilters.has(props.name),
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => (_unref(logStore).toggleFilter(props.name))),
    class: "rounded border align-top",
    "unmount-on-hide": false
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(CollapsibleTrigger), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(_ctx.label)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(CollapsibleContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(LogFilterTable, {
              data: _ctx.data,
              columns: _unref(columns),
              loading: _ctx.loading,
              class: "overflow-auto",
              onRowSelectionChange: handleFilterSelection
            }, null, 8, ["data", "columns", "loading"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})